import cookies from 'browser-cookies';
import type { SignUp } from '../../../types/definitions/vendor/graphql-schema.d';
import { isNonEmptyString } from '../../../utils/helpers';

export const ID_ME_SIGNUP_TYPE_COOKIE_NAME = 'id_me_signup_type';

/**
 * Signup types related to ID.me registration:
 * [source](https://github.com/stitchfix/client-service/blob/ceaccd3b73edfdde66f3a5bbd3e3cd68324e02fb/app/models/client_signup_type.rb#L3)
 */
const ID_ME_REGISTRATION_SIGNUP_TYPES = [
  'idme_government_worker_onboarding',
  'idme_military_onboarding',
  'idme_nurse_onboarding',
  'idme_teacher_onboarding',
] as const;

export type IDMeRegistrationSignupType =
  (typeof ID_ME_REGISTRATION_SIGNUP_TYPES)[number];

/**
 * The client's signupType value from the Graph
 */
export type IDmeClientSignUpType = Extract<
  SignUp,
  Uppercase<IDMeRegistrationSignupType>
>;

const getNormalizedIDmeRegistrationSignupType = (
  signupType: unknown,
): IDMeRegistrationSignupType | undefined => {
  if (!isNonEmptyString(signupType)) return undefined;

  const normalizedSignupType =
    signupType.toLowerCase() as IDMeRegistrationSignupType;

  return ID_ME_REGISTRATION_SIGNUP_TYPES.includes(normalizedSignupType)
    ? normalizedSignupType
    : undefined;
};

export const isIDmeClientSignUpType = (
  signupType?: SignUp,
): signupType is IDmeClientSignUpType => {
  if (!signupType) return false;

  return Boolean(getNormalizedIDmeRegistrationSignupType(signupType));
};

export const getIDmeRegistrationType = ({
  signupType,
}: {
  signupType?: unknown;
}) => getNormalizedIDmeRegistrationSignupType(signupType);

export const clearIDmeSignupCookie = () => {
  cookies.erase(ID_ME_SIGNUP_TYPE_COOKIE_NAME, {
    domain: '.stitchfix.com',
    path: '/',
  });
};
